import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

type ProtectedRouteProps = {
  children: React.ReactNode | (({ user }: { user: any }) => React.ReactNode);
  allowedRoles?: string[];
};

export default function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect nurses to their dashboard if they try to access admin routes
    if (user.role === "NURSE") {
      return <Navigate to="/nurse-dashboard" replace />;
    }
    // Default fallback for other unauthorized access
    return <Navigate to="/dashboard" replace />;
  }

  if (typeof children === "function") {
    return <>{children({ user })}</>;
  }

  return <>{children}</>;
}